import type { ReactNode } from "react";
import { QueryClientProvider } from "@tanstack/react-query";
import { PixelizeThemeProvider } from "pixelize-design-library";
import { queryClient } from "./query-client";

const themeOverrides = {
  components: {
    Button: {
      baseStyle: {
        borderRadius: "lg",
        fontWeight: 600,
        fontSize: "1rem",
        letterSpacing: "0.01em",
        transition: "all 0.2s",
        _disabled: { opacity: 0.6, cursor: "not-allowed" },
      },
    },
  },
};

export const Providers = ({ children }: { children: ReactNode }) => (
  <PixelizeThemeProvider
    brand="radiant"
    defaultMode="light"
    disablePersistence
    themeOverrides={themeOverrides}
  >
    <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
  </PixelizeThemeProvider>
);
